export const BASE_SHOPIFY_GRAPHQL_URL =
  "https://evrbed.myshopify.com/admin/api/2022-04/graphql.json";
export const BACKEND_BASE_URL =
  "https://u9csnx80lg.execute-api.ca-central-1.amazonaws.com/prod";
